import React from "react";
import trans from "../../../utils";

export default function PositionsPopupsHead({
	DeviceData,
	devicestatus,
	mark,
}) {
	console.log("DeviceData", DeviceData);
	return (
		<div className="device-popup-head">
			<div className="device-popup-name">
				{DeviceData && DeviceData[0]?.name}
			</div>
			<div className="device-popup-status" dir="ltr">
				<img
					src={
						mark?.attributes.motion
							? `${process.env.PUBLIC_URL}/assets/Moving.svg`
							: `${process.env.PUBLIC_URL}/assets/Stopped.svg`
					}
					alt="status"
				/>
				<div className="ms-1">
					{mark?.attributes.motion ? trans("Moving") : trans("Stopped")}
				</div>
			</div>
		</div>
	);
}
